import {Injectable} from '@angular/core';
import {HttpService} from './http-service';
import {Observable} from 'rxjs/Rx';

import {TAction, TChavecoFlag, TFinanceSide, TShareupTipo} from '../app/enum';
import {LogadoService} from "./logado-service";

@Injectable()
export class ProfileService {

    constructor(public http: HttpService, public logadoService: LogadoService) { //public injector: Injector

    }

    profile(action: TAction, profileID: number, json: any = null, params: string = ''): Observable<any> {

        let url = 'SYNC-Profile?Action=' + TAction[action] + '&ProfileID=' + profileID + params;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        let observ: Observable<any>;
        if ( json) observ = this.http.post(url, dataJSon);
        if (!json) observ = this.http.get(url);

        return observ.map(data => {

            return this.logadoService.profileJson(action, data);

        });

    }

    emissor(action: TAction, profileID: number, json: any = null, params: string = ''): Observable<any> {

        let url = 'SYNC-Emissor?Action=' + TAction[action] + '&ProfileID=' + profileID + params;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url);

    }

    account(action: TAction, accountID: number, profileID: number, hotspotID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Account?Action=' + TAction[action] + '&AccountID=' + accountID + '&ProfileID=' + profileID + '&HotspotID=' + hotspotID;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url);

    }

    address(action: TAction, addressID: number, profileID: number, json: any = null): Observable<any> {

        let url = 'SYNC-Address?Action=' + TAction[action] + '&AddressID=' + addressID + '&ProfileID=' + profileID;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url);

    }

    contato(action: TAction, profileID: number, json: any = null, params: string = '') {

        let url = 'SYNC-Contato?Action=' + TAction[action] + '&ProfileID=' + profileID + params;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url, {}, false);

    }

    plastic(action: TAction, profileID: number, plasticID: number, plasticSide: TFinanceSide = TFinanceSide.cdTodos, json: any = null): Observable<any> {

        let url = 'SYNC-Plastic?Action=' + TAction[action] + '&ProfileID=' + profileID + '&PlasticID=' + plasticID + '&PlasticSide=' + plasticSide;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url);

    }

    devicer(action: TAction, devicerID: number, profileID: number = 0, hotspotID: number = 0): Observable<any> {

        let url = 'SYNC-Devicer?Action=' + TAction[action] + '&DevicerID=' + devicerID + '&HotspotID=' + hotspotID + '&ProfileID=' + profileID;

        return this.http.get(url);

    }

    warning(action: TAction, warningID: number): Observable<any> {

        let url = 'SYNC-Warning?Action=' + TAction[action] + '&WarningID=' + warningID;

        return this.http.get(url);

    }

    findout(action: TAction, findText: string, profileID: number = 0, spotdayID: number = 0, hotspotID: number = 0): Observable<any> {

        let url = 'SYNC-Findout?Action=' + TAction[action] + '&Pesquisa=' + findText + '&ProfileID=' + profileID + '&SpotdayID=' + spotdayID + '&HotspotID=' + hotspotID;

        return this.http.get(url);

    }

    hotfeed(action: TAction, profileID: number): Observable<any> {

        let url = 'SYNC-Hotfeed?Action=' + TAction[action] + '&ProfileID=' + profileID;

        return this.http.get(url);

    }

    develop(action: TAction, developID: number = 0, limitPage: number = 0): Observable<any> {

        let url = 'SYNC-Develop?Action=' + TAction[action] + '&DevelopID=' + developID + '&LimitPage=' + limitPage;

        return this.http.get(url);

    }

    visitor(action: TAction, profileID: number, limitPage: number = 0): Observable<any> {

        let url = 'SYNC-Visitor?Action=' + TAction[action] + '&ProfileID=' + profileID + '&LimitPage=' + limitPage;

        return this.http.get(url);

    }

    central(action: TAction, notifyeID: string = '', profileID: number, meritumID: number = 0, limitPage: number = 0): Observable<any> {

        let url = 'SYNC-Notifye?Action=' + TAction[action] + '&NotifyeID=' + notifyeID + '&ProfileID=' + profileID + '&MeritumID=' + meritumID + '&LimitPage=' + limitPage;

        return this.http.get(url);

    }

    shareup(action: TAction, code: string, shareupTipo: TShareupTipo = TShareupTipo.shNone, json: any = null): Observable<any> {

        let url = 'SYNC-Shareup?Action=' + TAction[action] + '&Code=' + code + '&Tipo=' + shareupTipo;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url);

    }

    friendy(action: TAction, profileID: number, limitPage: number = 0, followup: number = 0, pesquisa: string = ''): Observable<any> {

        let url = 'SYNC-Friendy?Action=' + TAction[action] + '&ProfileID=' + profileID + '&Followup=' + followup + '&Pesquisa=' + pesquisa + '&LimitPage=' + limitPage + '&LimitQtde=200';

        return this.http.get(url);

    }

    chaveco(action: TAction, profileID: number = 0, limitPage: number = 0, hashtagID: number = 0, chavecoFlag: TChavecoFlag = TChavecoFlag.chNull): Observable<any> {

        let url = 'SYNC-Chaveco?Action=' + TAction[action] + '&ProfileID=' + profileID + '&HashtagID=' + hashtagID + '&ChavecoFlag=' + chavecoFlag + '&LimitPage=' + limitPage;

        return this.http.get(url);

    }

}



// WEBPACK FOOTER //
// ./src/providers/profile-service.ts